import { PropsWithChildren } from 'react';

import { DetailRow } from './DetailRow';
import { DetailRowLabel } from './DetailRowLabel';
import { DetailRowTooltip } from './DetailRowTooltip';
import { DetailRowValue } from './DetailRowValue';

interface DetailRowErrorProps extends PropsWithChildren {
  toolTipText?: string;
  variant?: 'default' | 'weak';
}

export function DetailRowError({ toolTipText, children, variant = 'default', ...props }: DetailRowErrorProps) {
  return (
    <DetailRow variant={variant} {...props}>
      <DetailRowLabel>
        {children}
        {toolTipText && <DetailRowTooltip>{toolTipText}</DetailRowTooltip>}
      </DetailRowLabel>
      <DetailRowValue>—</DetailRowValue>
    </DetailRow>
  );
}
